export default [
    {
        name: "supplierId",
        label: "Supplier",
        type: "list",
        helpText: "Supplier",
        url: "/suppliers",
        filterValue: "name",
        errorMessage: "Supplier is required",
        validation: {
            required: true,
        },
        include: true,
        entityName: "supplier",
    },
    {
        name: "operationModule",
        label: "Operation Module",
        type: "select",
        helpText: "Operation Module",
        errorMessage: "Operation Module is required",
        data: [
            { value: "monthly", text: "Monthly" },
            { value: "on_demand", text: "On-Demand" },
            { value: "monthly_and_on_demand", text: "Monthly and On-Demand" },
        ],
        validation: {
            required: true,
        },
    },
    {
        name: "contracted",
        label: "Contracted",
        type: "checkbox",
        helpText: "Contracted",
    },
    {
        name: "signDate",
        label: "Sign Date",
        type: "date",
        helpText: "Sign Date",
        errorMessage: "Sign Date is required",
        validation: {
            required: true,
        },
    },
    {
        name: "endDate",
        label: "End Date",
        type: "date",
        helpText: "End Date",
        errorMessage: "End Date is required",
        validation: {
            required: true,
        },
    },
];
